import { FRAMEBUFFER_HEIGHT, FRAMEBUFFER_WIDTH } from "../emulator.js";

import type { Renderer, RendererDebugState } from "./types.js";

export class Canvas2DRenderer implements Renderer {
  private readonly ctx: CanvasRenderingContext2D;
  private readonly imageData: ImageData;
  private presentCount = 0;
  private readonly debugState: RendererDebugState;

  constructor(
    private readonly canvas: HTMLCanvasElement,
    fallbackReason: string | null = null
  ) {
    const ctx = canvas.getContext("2d");
    if (ctx === null) {
      throw new Error("2D canvas context is not available");
    }

    this.canvas.width = FRAMEBUFFER_WIDTH;
    this.canvas.height = FRAMEBUFFER_HEIGHT;
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    this.ctx = ctx;
    this.imageData = ctx.createImageData(FRAMEBUFFER_WIDTH, FRAMEBUFFER_HEIGHT);
    this.debugState = {
      backend: "canvas2d",
      fallbackReason
    };
  }

  present(framebuffer: Uint8ClampedArray): void {
    this.imageData.data.set(framebuffer);
    this.ctx.putImageData(this.imageData, 0, 0);
    this.presentCount++;
  }

  getPresentCount(): number {
    return this.presentCount;
  }

  getDebugState(): RendererDebugState {
    return { ...this.debugState };
  }
}
